import { inject, InjectionToken } from '@angular/core';
import { LassiApplication } from '@core/api/angular';

export const IS_EMBEDDED = new InjectionToken<boolean>('IS_EMBEDDED_MAP', {
  factory: () => false,
});

export const APPLICATION = new InjectionToken<LassiApplication>(
  'Application Name',
  {
    factory: () => {
      const path = window.location.pathname.split('/').filter(Boolean)[0];
      switch (path) {
        case 'tpc':
          return LassiApplication.TPC;
        case 'vmt':
          return LassiApplication.VMT;
        case 'ohap':
          return LassiApplication.OHAP;
        case 'spear':
          return LassiApplication.SPEAR;
        default:
          return LassiApplication.LASSI;
      }
    },
  },
);

export const MAP_ROOT = new InjectionToken('MAP_ROOT', {
  factory: () => {
    const application = inject(APPLICATION);
    if (application === LassiApplication.LASSI) {
      return 'map';
    }
    return application.toLowerCase();
  },
});
